import React from 'react';
import { DroneEntity } from '@src/core/features';
import { FlightEntity } from '@src/features/order/entities';
import { PreviousFlights } from '@src/features/drone/pages/drones-page/maps/drones/types';

/**
 * Hook to compute flying drones with updated positions from flight data
 * Merges mission drones with fresh flight data or previous flight positions
 * 
 * @param missionDrones - Array of drones that are on a mission
 * @param previousFlights - Record of previous flight positions by serial number
 * @param flightData - Current flight data from WebSocket (may be null/undefined)
 * @returns Array of drones with updated latitude/longitude from flight data or previous positions
 */
export const useFlyingDrones = (
  missionDrones: DroneEntity[],
  previousFlights: PreviousFlights,
  flightData: FlightEntity | undefined | null
): DroneEntity[] => {
  return React.useMemo(() => {
    return missionDrones?.map((drone) => {
      const serial = drone.serialNumber;
      const prev = previousFlights[serial];
      const fresh = serial === flightData?.serialNumber ? flightData : null;

      return {
        ...drone,
        latitude: fresh?.latitude?.toString() 
          ?? prev?.latitude?.toString() 
          ?? drone.latitude,
        longitude: fresh?.longitude?.toString() 
          ?? prev?.longitude?.toString() 
          ?? drone.longitude
      };
    }) ?? [];
  }, [missionDrones, previousFlights, flightData]);
};

